import { get } from "lodash";
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header, Radio, Form } from "semantic-ui-react";
import { Field } from "formik";

import FormikSemanticDropdown from "../../forms/formik/FormikSemanticDropdown.jsx";
import SegmentMessage from "../../forms/messages/SegmentMessage.jsx";

import { PANEL_STATES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class RegionPanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    view: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired,
    selectedRegion: PropTypes.object,
    regionOptions: PropTypes.array.isRequired,
    selectedZone: PropTypes.object,
    zoneOptions: PropTypes.array.isRequired,

    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    name: "region",
    view: PANEL_STATES.INACTIVE,
    enableAdvancedSelection: false,
    copyKey: "project_wizard.region_panel"
  };

  constructor(props) {
    super(props);

    this.state = {
      showZone: get(props, "formikProps.values.zone", undefined) ? true : false
    };
  }

  onShowZone = (evt, data) => {
    this.setState({ showZone: data.checked });
  };

  // -- RENDER --//

  renderActive = () => {
    const { name, regionOptions, zoneOptions, apiErrors, copyKey, copy } =
      this.props;
    const { showZone } = this.state;

    return (
      <Fragment>
        <Header as="h3" attached="top" block>
          {copy(`${copyKey}.title`)}
        </Header>
        <Segment clearing={true} attached>
          <p>{copy(`${copyKey}.body`)}</p>

          <Field
            name={name}
            label={copy(`${copyKey}.dropdown_label`)}
            placeholder={copy(`${copyKey}.dropdown_placeholder`)}
            options={regionOptions}
            required={true}
            apiErrors={apiErrors}
            component={FormikSemanticDropdown}
          />

          <Fragment>
            <Form.Group>
              <Radio
                toggle
                data-testid="showZonesToggle"
                checked={showZone}
                label="Advanced users may want to select their AZ."
                onClick={this.onShowZone}
                style={{ marginLeft: "0.5em" }}
              />
            </Form.Group>

            {showZone && (
              <Field
                name="zone"
                label={copy(`${copyKey}.zone_dropdown_label`)}
                placeholder={copy(`${copyKey}.zone_dropdown_placeholder`)}
                options={zoneOptions}
                required={true}
                apiErrors={apiErrors}
                component={FormikSemanticDropdown}
              />
            )}
          </Fragment>
        </Segment>
      </Fragment>
    );
  };

  renderSet = () => {
    const { selectedRegion, copyKey, copy } = this.props;

    if (selectedRegion && selectedRegion.readonly) {
      return (
        <SegmentMessage
          title={copy(`${copyKey}.messages.already_set_readonly.title`)}
          message={copy(`${copyKey}.messages.already_set_readonly.message`)}
          negative={true}
          style={{ marginTop: "2em" }}
        />
      );
    }

    return null;
  };

  renderInactive = () => {
    return null;
  };

  render() {
    const { view, selectedRegion } = this.props;

    switch (view) {
      case PANEL_STATES.ACTIVE:
        if (selectedRegion) {
          return this.renderSet();
        } else {
          return this.renderActive();
        }
      default:
        return this.renderInactive();
    }
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(RegionPanel);
